import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
          {t("cta.title")}
        </h2>
        <p className="mt-4 text-base md:text-lg text-foreground-600">
          {t("cta.subtitle")}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          {t("cta.button")}
          <i className="ri-arrow-right-line"></i>
        </a>

        {/* Floating product images decoration */}
        <div className="mt-12 flex justify-center gap-4 md:gap-6 flex-wrap opacity-30">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20elegant%20tan%20leather%20loafer%20shoe%20isolated%20on%20clean%20off-white%20background%20minimal%20product%20photography%20soft%20diffused%20lighting%20subtle%20shadow%20refined%20commercial%20quality&width=200&height=200&seq=float-shoe-v2-031&orientation=squarish"
              alt="Sneaker"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20structured%20charcoal%20gray%20canvas%20backpack%20with%20leather%20trim%20details%20isolated%20on%20clean%20off-white%20background%20minimal%20product%20photography%20soft%20diffused%20lighting%20subtle%20shadow%20refined%20commercial%20quality&width=200&height=200&seq=float-bag-v2-032&orientation=squarish"
              alt="Bag"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20minimalist%20sand%20colored%20bucket%20hat%20with%20subtle%20stitch%20detail%20isolated%20on%20clean%20off-white%20background%20minimal%20product%20photography%20soft%20diffused%20lighting%20subtle%20shadow%20refined%20commercial%20quality&width=200&height=200&seq=float-hat-v2-033&orientation=squarish"
              alt="Cap"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20sleek%20minimalist%20amber%20glass%20perfume%20bottle%20with%20clean%20label%20design%20isolated%20on%20clean%20off-white%20background%20minimal%20product%20photography%20soft%20diffused%20lighting%20subtle%20shadow%20and%20reflection%20refined%20commercial%20quality&width=200&height=200&seq=float-perfume-v2-034&orientation=squarish"
              alt="Perfume"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}